import React, { useEffect } from "react";
import { connect } from "react-redux";
import LobbyRoutes from "./LobbyRoutes";
import LmsRoutes from "./LmsRoutes";
import { clearSession } from "../processes/sessionProcesses";

function RoutesContainer({
  loggedIn,
  path,
  confirmingAccount,
  dispatch,
  ...rest
}) {
  useEffect(() => {
    dispatch({ type: "AFTER_SIGN_IN_PATH", path });
  }, []);

  // When landing on the account-confirmation flow with another account still
  // logged in, drop the stale session first so the user sees the confirmation
  // screen instead of being routed into the wrong logged-in account.
  useEffect(() => {
    if (confirmingAccount && loggedIn) {
      clearSession(dispatch);
    }
  }, [confirmingAccount, loggedIn]);

  if (confirmingAccount && loggedIn) return null;

  return loggedIn ? <LmsRoutes {...rest} /> : <LobbyRoutes {...rest} />;
}

function mapStateToProps(state) {
  const { currentUserId, router } = state;
  const location = router.location;

  return {
    loggedIn: !!currentUserId,
    path: location.pathname + location.search,
    confirmingAccount: location.search.includes("confirmed"),
  };
}

export default connect(mapStateToProps)(RoutesContainer);
